import { useState } from 'react'
import { Head, Link, router, usePage } from '@inertiajs/react'
import SuperAdminLayout from '../_SuperAdminLayout'

export default function NewGuide() {
  const { errors } = usePage().props as unknown as { errors: Record<string, string | string[]> }
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const err = (k: string): string | null => {
    const v = errors?.[k]
    if (!v) return null
    return Array.isArray(v) ? v[0] : v
  }

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    setSubmitting(true)
    router.post('/super_admin/guides', {
      guide: { first_name: firstName, last_name: lastName, email, password },
    }, { onFinish: () => setSubmitting(false) })
  }

  return (
    <SuperAdminLayout>
      <Head title="Create Guide" />
      <div className="max-w-lg">
        <div className="flex items-center gap-2 mb-6">
          <Link href="/super_admin/guides" className="text-sm text-text-muted hover:text-text-primary">&larr; Guides</Link>
        </div>
        <h1 className="text-2xl font-bold text-text-primary mb-2">Create Guide</h1>
        <p className="text-sm text-text-muted mb-6">
          Guides are created by SuperAdmins only. If the email already belongs to
          an existing account, a Guide identity is added to it — leave the
          password blank in that case.
        </p>

        {err('base') && (
          <div className="mb-4 px-4 py-3 bg-[#ED1C24]/10 text-[#ED1C24] rounded-lg text-sm">{err('base')}</div>
        )}

        <form onSubmit={submit} className="bg-white border border-stone/20 rounded-lg p-6 space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <Field label="First name" value={firstName} onChange={setFirstName} />
            <Field label="Last name" value={lastName} onChange={setLastName} />
          </div>
          <Field label="Email" type="email" value={email} onChange={setEmail} error={err('email')} />
          <Field
            label="Password (new accounts only)"
            type="text"
            value={password}
            onChange={setPassword}
            error={err('password')}
            placeholder="Min 6 characters"
          />

          <div className="flex justify-end gap-3 pt-2">
            <Link href="/super_admin/guides" className="px-4 py-2 text-sm text-text-primary">Cancel</Link>
            <button
              type="submit"
              disabled={submitting || !email.trim() || !firstName.trim() || !lastName.trim()}
              className="px-5 py-2 bg-[#351E1D] text-white text-sm font-semibold rounded-lg hover:bg-[#351E1D]/90 disabled:opacity-50"
            >
              {submitting ? 'Creating...' : 'Create Guide'}
            </button>
          </div>
        </form>
      </div>
    </SuperAdminLayout>
  )
}

function Field({ label, value, onChange, type = 'text', error, placeholder }: {
  label: string
  value: string
  onChange: (v: string) => void
  type?: string
  error?: string | null
  placeholder?: string
}) {
  return (
    <div>
      <label className="block text-sm font-medium text-text-primary mb-1.5">{label}</label>
      <input
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full border border-stone/30 rounded-lg px-3 py-2 text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-charcoal/40 focus:border-charcoal"
      />
      {error && <p className="text-xs text-[#ED1C24] mt-1">{error}</p>}
    </div>
  )
}
